import React, { useCallback, useEffect, useState } from "react";
import { useInput } from "react-admin";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { debounce, find } from "lodash";
import axios from "axios";
import { useField } from "react-final-form";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { ONEMAP_SEARCH_ADDRESS_API_URL } from "utils/const";

const useStyles = makeStyles({
  root: {
    marginTop: "8px",
    paddingBottom: "3px",
    "& .MuiOutlinedInput-root": {
      padding: "6px",
      borderRadius: "10px",
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

export default function AddressAutoCompleteInput(props: any) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const {
    input: { onChange },
  } = useField(props.referenceSource);

  const { options, ...rest } = props;

  const {
    input,
    meta: { touched, error },
  } = useInput(rest);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callAddressApi = useCallback(
    debounce((searchVal: string) => {
      axios
        .request({
          method: "GET",
          url: `${ONEMAP_SEARCH_ADDRESS_API_URL}`,
          params: {
            searchVal,
            getAddrDetails: "Y",
            returnGeom: "Y",
            pageNum: 1,
          },
        })
        .then((res) => {
          if (res.data.found >= 1) {
            setAddressOptions(
              res.data.results.map((item: any) => `${item.ADDRESS}`),
            );
            setLocationData(res.data.results);
            setLoading(false);
          } else {
            setAddressOptions([]);
            setLocationData([]);
            setLoading(false);
          }
        })
        .catch((e) => {
          setAddressOptions([]);
          setLocationData([]);
          setLoading(false);
        });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (input.value !== "") {
      setLoading(true);
      callAddressApi(input.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.value]);

  return (
    <Autocomplete
      style={props.style}
      className={classes.root}
      options={addressOptions}
      onChange={(event, newValue) => {
        input.onChange(newValue);

        const selectedLocation = find(locationData, { ADDRESS: newValue });
        onChange(selectedLocation);

        props.onChange && props.onChange(selectedLocation);
      }}
      freeSolo
      disableClearable
      value={input.value}
      inputValue={input.value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          error={!!(touched && error)}
          helperText={touched && error}
          {...input}
          InputProps={{
            ...params.InputProps,
            type: "search",
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
